/* PDP buy box — inject editable subtexts under the Size/Supply cards.
   The map (option value -> subtext) lives in an editable JSON script
   (#pdp-card-subtexts) rendered from a custom-liquid block in the template,
   so the merchant can change it in the customizer without touching code. */

(function () {
  function injectSubtexts() {
    var mapEl = document.getElementById("pdp-card-subtexts");
    if (!mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var items = document.querySelectorAll(
      ".template-product .wt-product__option .f-button__list__item",
    );
    items.forEach(function (item) {
      var input = item.querySelector("input");
      var label = item.querySelector(".f-button__list__link");
      if (!input || !label) return;
      if (label.querySelector(".pdp-card-sub")) return; // already injected

      var subtext = map[input.value];
      if (!subtext) return;

      // wrap the existing value text so it can sit above the subtext
      if (!label.querySelector(".pdp-card-main")) {
        var main = document.createElement("span");
        main.className = "pdp-card-main";
        // move existing text nodes into the main span
        while (label.firstChild) main.appendChild(label.firstChild);
        label.appendChild(main);
      }

      subtext.split("|").forEach(function (line, i) {
        var sub = document.createElement("span");
        sub.className = i === 0 ? "pdp-card-sub" : "pdp-card-sub pdp-card-dose";
        sub.textContent = line.trim();
        label.appendChild(sub);
      });
    });
  }

  // Replace the option titles (e.g. "Dog Size:") with editable step labels
  // (e.g. "1 · Choose your dog's size") and hide the inline selected value.
  function setOptionTitles() {
    var mapEl = document.getElementById("pdp-option-titles");
    if (!mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    document
      .querySelectorAll(".template-product .wt-product__option__title")
      .forEach(function (title) {
        var labelSpan = title.querySelector(".label");
        var valueSpan = title.querySelector(".value");
        if (!labelSpan) return;
        var name = labelSpan.textContent.replace(/:\s*$/, "").trim();
        if (!map[name]) return;
        labelSpan.textContent = map[name];
        if (valueSpan) valueSpan.style.display = "none";
        title.classList.add("pdp-option-title--custom");
      });
  }

  // Reorder to Size (1) -> Plan (2) -> Supply (3): move the plan label + the
  // Recharge widget to sit between the two variant options, inside
  // <variant-options> (so variants.js still tracks both options).
  function reorderPlanBeforeSupply() {
    var vo = document.querySelector(".template-product variant-options");
    if (!vo) return;
    var options = vo.querySelectorAll(".wt-product__option");
    if (options.length < 2) return;
    var supply = options[1];

    var planLabel = document.querySelector(".template-product .pdp-step-label");
    if (!planLabel || planLabel.dataset.moved) return;
    var planWidget = planLabel.nextElementSibling; // the Recharge app block

    vo.insertBefore(planLabel, supply);
    if (planWidget) vo.insertBefore(planWidget, supply);
    planLabel.dataset.moved = "true";
  }

  // Find the currently-checked Recharge purchase option by walking open shadow
  // roots (the widget uses shadowrootmode="open", so we can read into it).
  function findCheckedPurchaseOption(root) {
    root = root || document;
    if (root.querySelector) {
      var input = root.querySelector('input[name="purchaseOption"]:checked');
      if (input) return input;
    }
    var nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        var found = findCheckedPurchaseOption(nodes[i].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function getSupplyOption() {
    var vo = document.querySelector(".template-product variant-options");
    if (!vo) return null;
    var opts = vo.querySelectorAll(".wt-product__option");
    return opts.length > 1 ? opts[opts.length - 1] : null;
  }

  function priceToNumber(t) {
    var n = parseFloat((t || "").replace(/[^0-9.]/g, ""));
    return isNaN(n) ? 0 : n;
  }

  // The displayed price of the currently-selected Recharge purchase option.
  // The .rc-price node holds a visually-hidden a11y label (", Discounted price:")
  // before the amount — strip it so we keep only the price.
  function getSelectedPriceText() {
    var input = findCheckedPurchaseOption();
    if (!input) return null;
    var opt = input.closest(".rc-purchase-option");
    if (!opt) return null;
    var p = opt.querySelector(".rc-price:not(.strike-through)");
    if (!p) return null;
    var clone = p.cloneNode(true);
    clone.querySelectorAll(".visually-hidden").forEach(function (el) {
      el.remove();
    });
    return clone.textContent.replace(/\s+/g, " ").trim();
  }
    // Strikethrough (compare-at) price of the selected purchase option, if any.
  function getSelectedStrikePriceText() {
    var input = findCheckedPurchaseOption();
    if (!input) return null;
    var opt = input.closest(".rc-purchase-option");
    if (!opt) return null;
    var p = opt.querySelector(".rc-price.strike-through");
    if (!p) return null;
    var clone = p.cloneNode(true);
    clone.querySelectorAll(".visually-hidden").forEach(function (el) {
      el.remove();
    });
    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  function getSelectedSupplyMonths() {
    var supply = getSupplyOption();
    if (!supply) return 1;
    var c = supply.querySelector("input:checked");
    var m = c ? parseInt(c.value, 10) : 1;
    return isNaN(m) ? 1 : m;
  }

  // Price line (selected price + cost/day) and the add-to-cart button label.
  function updatePriceUI(isSubscribe) {
    var priceText = getSelectedPriceText();

    var priceEl = document.querySelector(".template-product .pdp-price");
    if (priceEl) priceEl.textContent = priceText || "";

    var perdayEl = document.querySelector(".template-product .pdp-perday");
    if (perdayEl) {
      var days = isSubscribe ? 30 : getSelectedSupplyMonths() * 30;
      var num = priceToNumber(priceText);
      perdayEl.textContent =
        num && days ? "$" + (num / days).toFixed(2) + " / day" : "";
    }

      var btnSpan = document.querySelector('.template-product [name="add"] > span');
    if (btnSpan && priceText) {
      var strikeText = isSubscribe ? getSelectedStrikePriceText() : null;
      var label = isSubscribe ? "Add to Cart — " : "Add to cart — ";
      if (strikeText && strikeText !== priceText) {
          btnSpan.innerHTML = label + '<b>' + priceText + '</b> <s class="pdp-btn-strike">' + strikeText + '</s>';

      } else {
        btnSpan.textContent = label + priceText;
      }
    }
  }

  // Subscribe always uses the base (lowest available) supply, so it shows 1 jar
  // / the 1-month image + price — not whatever Shopify defaults to (e.g. 3 months).
  function selectBaseSupply() {
    var supply = getSupplyOption();
    if (!supply) return;
    var base = null,
      baseMonths = Infinity;
    supply.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      if (inp.classList.contains("disabled")) return;
      var li = inp.closest("li");
      if (li && li.classList.contains("wt-variant-option--hidden")) return;
      var m = parseInt(inp.value, 10);
      if (!isNaN(m) && m < baseMonths) {
        baseMonths = m;
        base = inp;
      }
    });
    if (base && !base.checked) {
      base.checked = true;
      base.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Subscribe -> hide Supply (forced to base supply). One-time -> show Supply.
  function updatePlanDependentUI() {
    var supply = getSupplyOption();
    var checked = findCheckedPurchaseOption();
    var isSubscribe = !checked || checked.value === "subscription";

    if (isSubscribe) selectBaseSupply();

    if (supply) supply.style.display = isSubscribe ? "none" : "";

    updatePriceUI(isSubscribe);
    updateStickyFooter(isSubscribe);
  }

  // Tag the Supply option (for the 3-up grid) and sort its cards 1 → 2 → 3 month.
  function setupSupply() {
    var supply = getSupplyOption();
    if (!supply) return;
    supply.classList.add("pdp-supply");
    var ul = supply.querySelector(".f-button__list");
    if (!ul) return;
    var items = Array.prototype.slice.call(
      ul.querySelectorAll(".f-button__list__item"),
    );
    items.sort(function (a, b) {
      var ia = a.querySelector("input"),
        ib = b.querySelector("input");
      var ma = ia ? parseInt(ia.value, 10) : 99;
      var mb = ib ? parseInt(ib.value, 10) : 99;
      return (isNaN(ma) ? 99 : ma) - (isNaN(mb) ? 99 : mb);
    });
    items.forEach(function (it) {
      ul.appendChild(it);
    });
  }

  function getCheckedSizeText() {
    var first = document.querySelector(
      ".template-product variant-options .wt-product__option",
    );
    var c = first && first.querySelector("input:checked");
    return c ? c.value : "";
  }
  function getCheckedSupplyText() {
    var supply = getSupplyOption();
    var c = supply && supply.querySelector("input:checked");
    return c ? c.value : "";
  }

  // Build the sticky add-to-cart bar once; show it after the buy box scrolls past.
  function buildStickyFooter() {
    if (document.querySelector(".pdp-sticky-footer")) return;
    var titleEl = document.querySelector(".template-product .wt-product__name");
    var footer = document.createElement("div");
    footer.className = "pdp-sticky-footer";
    footer.innerHTML =
      '<div class="pdp-sticky-footer__info">' +
      '<span class="pdp-sticky-footer__title"></span>' +
      '<span class="pdp-sticky-footer__sub"></span>' +
      "</div>" +
      '<button type="button" class="pdp-sticky-footer__btn"></button>';
    footer.querySelector(".pdp-sticky-footer__title").textContent = titleEl
      ? titleEl.textContent.trim()
      : "";
    document.body.appendChild(footer);

    footer
      .querySelector(".pdp-sticky-footer__btn")
      .addEventListener("click", function () {
        var addBtn = document.querySelector('.template-product [name="add"]');
        if (addBtn) addBtn.click();
      });

    var target = document.querySelector('.template-product [name="add"]');
    if (target && "IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            footer.classList.toggle(
              "pdp-sticky-footer--show",
              !e.isIntersecting,
            );
          });
        },
        { rootMargin: "0px 0px -10% 0px" },
      ).observe(target);
    }
  }

  function updateStickyFooter(isSubscribe) {
    var footer = document.querySelector(".pdp-sticky-footer");
    if (!footer) return;
    var size = getCheckedSizeText();
    var plan = isSubscribe ? "Subscribe" : "One-time";
    var supply = isSubscribe ? "" : getCheckedSupplyText();
    footer.querySelector(".pdp-sticky-footer__sub").textContent = [
      size,
      plan,
      supply,
    ]
      .filter(Boolean)
      .join(" · ");
    var price = getSelectedPriceText();
    footer.querySelector(".pdp-sticky-footer__btn").textContent =
      (isSubscribe ? "Subscribe — " : "Add to cart — ") + (price || "");
  }

  function run() {
    injectSubtexts();
    setOptionTitles();
    reorderPlanBeforeSupply();
    setupSupply();
    buildStickyFooter();
    updatePlanDependentUI();
  }

  function startup() {
    run();
    // Recharge loads async — retry so the price/button label populate once ready.
    [300, 800, 1500, 2500].forEach(function (d) {
      setTimeout(updatePlanDependentUI, d);
    });
  }

  if (document.readyState !== "loading") {
    startup();
  } else {
    document.addEventListener("DOMContentLoaded", startup);
  }

  // Re-evaluate after any click inside the buy box (catches the Recharge
  // subscribe/one-time toggle — clicks bubble out of the open shadow root).
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("variant-options")) {
      setTimeout(updatePlanDependentUI, 80);
    }
  });

  // Re-evaluate on variant change (size switch may re-render the widget).
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined" &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(updatePlanDependentUI, 80);
    });
  }
})();
